// eslint-disable-next-line no-restricted-imports
import { MoonIcon, SunIcon } from '@heroicons/react/solid'
import { Trans } from '@lingui/macro'
import { PrivacyPolicyModal } from 'components/PrivacyPolicy'
import { LOCALE_LABEL, SupportedLocale } from 'constants/locales'
import { useLocationLinkProps } from 'hooks/useLocationLinkProps'
import { useOnClickOutside } from 'hooks/useOnClickOutside'
import useTheme from 'hooks/useTheme'
import { useActiveWeb3React } from 'hooks/web3'
import { useEffect, useMemo, useRef, useState } from 'react'
import { ArrowDownCircle, Check, ChevronDown } from 'react-feather'
import { useRefinementList, UseRefinementListProps, useToggleRefinement } from 'react-instantsearch-hooks'
import { useDispatch } from 'react-redux'
import { Link } from 'react-router-dom'
import { useModalOpen, useToggleModal } from 'state/application/hooks'
import { addRefinementListValue, clearAllValues, removeRefinementListValue } from 'state/search/actions'
import { useRefinementListValue } from 'state/search/hooks'
import { SearchRefinementIndex, SearchSaleStateKey } from 'state/search/reducer'
import { useDarkModeManager } from 'state/user/hooks'
import styled, { css } from 'styled-components/macro'
import { ExternalLink, IconWrapper, TYPE } from 'theme'

// import { ReactComponent as Logo } from '../../assets/svg/logo.svg'
import { FilterFlyout, FlyoutAlignment } from '../styled'

const ActiveRowWrapper = styled.div`
  background-color: ${({ theme }) => theme.bg2};
  border-radius: 8px;
  cursor: pointer;
  padding: 8px 0 8px 0;
  width: 100%;
`
export const FlyoutRow = styled.div<{ active: boolean }>`
  align-items: center;
  background-color: ${({ active, theme }) => (active ? theme.bg2 : 'transparent')};
  border-radius: 12px;
  cursor: pointer;
  display: flex;
  font-weight: 500;
  justify-content: space-between;
  padding: 6px 12px;
  text-align: left;
  width: 100%;
`

const StyledOptionBubble = styled.div<{ active: boolean }>`
  align-items: center;
  // background-color: ${({ active, theme }) => (active ? theme.bg2 : 'transparent')};
  border: 1px solid ${({ active, theme }) => (active ? theme.bg0 : theme.bg2)};
  border-radius: 12px;
  cursor: pointer;
  display: flex;
  font-weight: 500;
  justify-content: space-between;
  padding: 6px 12px;
  text-align: left;
  width: 100%;
`

const FlyoutRowActiveIndicator = styled.div`
  background-color: ${({ theme }) => theme.green1};
  border-radius: 50%;
  height: 9px;
  width: 9px;
`
const Logo = styled.img`
  height: 20px;
  width: 20px;
  margin-right: 8px;
`
const NetworkLabel = styled.div`
  flex: 1 1 auto;
`
const OptionRowList = styled.div`
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 8px;
`
const OptionBubbleList = styled.div`
  margin-top: 12px;
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 3px;
`

// function OptionBubble({ text, handleClick, active }: { text: string; handleClick: () => void; active: boolean }) {
//   const RowContent = () => (
//     <StyledOptionBubble onClick={handleClick} active={active}>
//       <NetworkLabel>{text}</NetworkLabel>
//       {active && <FlyoutRowActiveIndicator />}
//     </StyledOptionBubble>
//   )
//   return <RowContent />
// }

export type OptionRowProps = {
  text: string
  handleClick: () => void
  active: boolean
}

export default function MintsStatusFlyout() {
  const node = useRef<HTMLDivElement>()
  const open = useModalOpen('MintsCollectionFilter')
  const toggleMenu = useToggleModal('MintsCollectionFilter')
  useOnClickOutside(node, open ? toggleMenu : undefined)

  const theme = useTheme()
  const dispatch = useDispatch()

  const liveSale = useRefinementListValue(SearchRefinementIndex.SaleState, SearchSaleStateKey.LiveSale)
  const liveOffer = useRefinementListValue(SearchRefinementIndex.SaleState, SearchSaleStateKey.LiveOffer)

  return (
    <FilterFlyout>
      <TYPE.heavy fontSize={14} color={theme.text2}>
        Sale status
      </TYPE.heavy>
      <OptionRowList>
        <FlyoutRow
          onClick={() => {
            dispatch(
              clearAllValues({
                index: SearchRefinementIndex.SaleState,
              })
            )
            toggleMenu()
          }}
          active={!liveSale && !liveOffer}
        >
          <NetworkLabel>All</NetworkLabel>
          {liveSale && <FlyoutRowActiveIndicator />}
        </FlyoutRow>
        <FlyoutRow
          onClick={() => {
            if (liveSale) {
              dispatch(
                removeRefinementListValue({
                  index: SearchRefinementIndex.SaleState,
                  value: SearchSaleStateKey.LiveSale,
                })
              )
            } else {
              dispatch(
                addRefinementListValue({
                  index: SearchRefinementIndex.SaleState,
                  value: SearchSaleStateKey.LiveSale,
                })
              )
            }
            toggleMenu()
          }}
          active={liveSale ?? false}
        >
          <NetworkLabel>Live sale</NetworkLabel>
          {liveSale && <FlyoutRowActiveIndicator />}
        </FlyoutRow>
        <FlyoutRow
          onClick={() => {
            if (liveOffer) {
              dispatch(
                removeRefinementListValue({
                  index: SearchRefinementIndex.SaleState,
                  value: SearchSaleStateKey.LiveOffer,
                })
              )
            } else {
              dispatch(
                addRefinementListValue({
                  index: SearchRefinementIndex.SaleState,
                  value: SearchSaleStateKey.LiveOffer,
                })
              )
            }
            toggleMenu()
          }}
          active={liveOffer ?? false}
        >
          <NetworkLabel>Active offer</NetworkLabel>
          {liveOffer && <FlyoutRowActiveIndicator />}
        </FlyoutRow>
      </OptionRowList>
    </FilterFlyout>
  )
}
